import type { IModulo } from "./entidades/IModulo";
import { type IRespuestaApiObjeto } from "../../globales/interfaces";
import api from "../../utils/api";
import type { IRespuestaModulos } from "./entidades/IRespuestaModulos";

export class ModuloModelo {
    

    constructor() { }
    public async obtenerListaModulos(): Promise<IRespuestaApiObjeto<IRespuestaModulos>> {
        const { data } = await api.get(
            `/api/ModuloChecklist/ObtenerCatalogos`, {
            headers: {
                "Content-Type": "application/json"
            },
        });
        return data;
    }

    public async crearModulo(Modulo: IModulo): Promise<IRespuestaApiObjeto<IModulo>> {
        const { data } = await api.post(
            `/api/ModuloChecklist/Crear`, Modulo, {
            headers: {
                "Content-Type": "application/json"

            },
        });
        return data;
    }

    public async editarModulo(Modulo: IModulo): Promise<IRespuestaApiObjeto<IModulo>> {
        const { data } = await api.put(
            `/api/ModuloChecklist/Actualizar`, Modulo, {
            headers: {
                "Content-Type": "application/json"

            },
        });
        return data;
    }

    public async eliminarModulo(Modulo: IModulo): Promise<IRespuestaApiObjeto<IModulo>> {
        const { data } = await api.delete(
            `/api/ModuloChecklist/Actualizar/${Modulo.Id}`, {
            headers: {
                "Content-Type": "application/json"

            },
        });
        return data;
    }

        public async obtenerListaModulosPorTipoEquipo(IdTipoEquipo: number): Promise<IRespuestaApiObjeto<IRespuestaModulos>> {
        const { data } = await api.get(
            `/api/ModuloChecklist/ObtenerCatalogos/?tipoEquipo=${IdTipoEquipo}`, {
            headers: {
                "Content-Type": "application/json"
            },
        });
        return data;
    }

}

